import { userDTO } from "../../types/types";
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { Course } from "../../types/types";
  type Quizez = {
    studentId: string,
    quizName: string,
    status: string,
    num_tries: number,
    score: number
  }
  export type StudentCourse = Course & {
    progress:{
      videoWatched:number;
      totalVideos:number;
      percentage:number
    }
  }
  type StudentProfile =   {
    student:userDTO
    quizez:Quizez[]
    courses:StudentCourse[]
  }
  
  type StudentsResponse = {
    statusCode?: number;
    error?: null | ApiError;
    data?: StudentProfile
    }
  export const getStudentProfile = async (id:string): Promise<StudentsResponse> => {
      try {
          const response = await axios.get(`/admin/oneStudentDetails/${id}`);
          
         return {data:response.data}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
          console.error("API Error:", error);
          if (error.response) {
              const apiError: ApiError = {
                  statusCode: error.response.status,
                  message: error.response.data.message,
                  error: error.response.data.error,
              };
              return { error: apiError };
          } else {
              const fallbackError: ApiError = {
                  statusCode: 500,
                  message: "An unexpected error occurred",
              };
              return { error: fallbackError };
          }
      }
  };